import Waveform from "./icons/Waveform.js";
import TripInterruption from "./icons/TripInterruption.js";
import Sparkle from "./icons/Sparkle.js";
import Refund from "./icons/Refund.js";
import PricelineP from "./icons/PricelineP.js";
import Penny from "./icons/Penny.js";
import PackageOutline from "./icons/PackageOutline.js";
import Package from "./icons/Package.js";
import HotelOutline from "./icons/HotelOutline.js";
import Hotel from "./icons/Hotel.js";
import FlightOutline from "./icons/FlightOutline.js";
import Flight from "./icons/Flight.js";
import Disney from "./icons/Disney.js";
import DiscountFill from "./icons/DiscountFill.js";
import Discount from "./icons/Discount.js";
import CruiseOutline from "./icons/CruiseOutline.js";
import Cruise from "./icons/Cruise.js";
import CarOutline from "./icons/CarOutline.js";
import Car from "./icons/Car.js";
import AiSearch from "./icons/AiSearch.js";
const iconRegistry = {
    Waveform: Waveform,
    TripInterruption: TripInterruption,
    Sparkle: Sparkle,
    Refund: Refund,
    PricelineP: PricelineP,
    Penny: Penny,
    PackageOutline: PackageOutline,
    Package: Package,
    HotelOutline: HotelOutline,
    Hotel: Hotel,
    FlightOutline: FlightOutline,
    Flight: Flight,
    Disney: Disney,
    DiscountFill: DiscountFill,
    Discount: Discount,
    CruiseOutline: CruiseOutline,
    Cruise: Cruise,
    CarOutline: CarOutline,
    Car: Car,
    AiSearch: AiSearch
};
export { iconRegistry };
